/**
 * Copia un texto al portapapeles del usuario.
 * Usa la API moderna `navigator.clipboard` si está disponible,
 * con fallback a `execCommand('copy')` para entornos sin soporte.
 *
 * @param value - Texto a copiar.
 * @param onSuccess - Callback ejecutado cuando la copia fue exitosa.
 */
export function copyToClipboard(value: string, onSuccess: () => void): void {
  if (navigator?.clipboard?.writeText) {
    navigator.clipboard
      .writeText(value)
      .then(onSuccess)
      .catch(() => fallbackCopy(value, onSuccess));
    return;
  }
  fallbackCopy(value, onSuccess);
}

/**
 * Exposes clipboard utilities as a mutable object to allow test spying.
 */
export const ClipboardUtils = { copyToClipboard };

function fallbackCopy(value: string, onSuccess: () => void): void {
  const textarea = document.createElement('textarea');
  textarea.value = value;
  textarea.setAttribute('readonly', 'true');
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();

  try {
    const ok = document.execCommand('copy');
    if (ok) {
      onSuccess();
    }
  } finally {
    document.body.removeChild(textarea);
  }
}
